import { useFetch } from "../../../_hooks/use-fetch";
import { ISubscriptionRateGetResponse } from "./types";


export const useAccountApi = () => {
  const fetch = useFetch();

  return {
    getSubscriptionRates: async (): Promise<ISubscriptionRateGetResponse[]> => {
      return await fetch(
        `${process.env.REACT_APP_API_ACCOUNT_MANAGER}/v1/subscription/rates`,
        "GET"
      );
    },
  };
};
